import React from 'react';
import { Alert } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';

interface VehiclePreventativeMaintenanceSectionProps {
  vehicle: Vehicle;
}

const VehiclePreventativeMaintenanceSection: React.FC<VehiclePreventativeMaintenanceSectionProps> = ({ vehicle }) => {
  return (
    <div>
      <h2>Preventative Maintenance</h2>
      <Alert variant="info">
        <i className="bi bi-info-circle tw-mr-2"></i>
        This feature is not yet developed.
      </Alert>
    </div>
  );
};

export default VehiclePreventativeMaintenanceSection;

